// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2xzCG","savePackageButton":"ClientWallet_savePackageButton__Yr9ZA"};